<div class="flex flex-col min-h-[100vh]">
  <div class="sticky top-0 z-50 shadow-md" *ngIf="showHeaderAndFooter">
    <psc-header></psc-header>
    <!-- This nav gives you links to click, which tells the router which route to use (defined in the routes constant in  AppRoutingModule) -->
    <psc-navigation></psc-navigation>

    <psc-warning-bar></psc-warning-bar>
  </div>
  <!-- The routed views render in the <router-outlet>-->
  <div class="flex-1">
    <router-outlet (activate)="modifyHeader()"></router-outlet>
  </div>

  <psc-footer
    *ngIf="showHeaderAndFooter"></psc-footer>

  <div class="fixed top-[50px] right-2 z-50">
    <psc-toast></psc-toast>
  </div>

  <!-- Full page loader -->
  <div *ngIf="loading$ | async"
       class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-white/60 flex flex-col items-center justify-center">
    <psc-loader></psc-loader>
    <div @inOutAnimation
         *ngIf="showLoadingText"
         class="text-center mt-4 text-sun-yellow p-1 rounded-xl text-xl bg-white font-bold">{{'loading_long' | transloco}}</div>
  </div>

  <!-- Back to top button -->
  <button
    *ngIf="showHeaderAndFooter"
    type="button"
    aria-label="Go to top"
    class="fixed inline-block p-3 bg-blue2 leading-tight rounded-full shadow-md hover:bg-blue3 hover:shadow-lg active:scale-90 transition duration-150 ease-in-out bottom-5 right-5"
    (click)="onScrollToTopClick()">
    <i class="pvsc-icon text-[16px] text-color-white icon-up-arrow"></i>
  </button>

  <psc-common-dialogs></psc-common-dialogs>
</div>
